import React from 'react';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

const PRESETS = [
  { value: 'THIS_MONTH', label: 'Bu Ay' },
  { value: 'LAST_30_DAYS', label: 'Son 30 Gün' },
  { value: 'THIS_YEAR', label: 'Bu Yıl' },
  { value: 'CUSTOM', label: 'Özel Aralık' },
];

function formatLocalDateISO(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

function getMonthStartISO() {
  const d = new Date();
  d.setDate(1);
  return formatLocalDateISO(d);
}

export default function AccountingDateFilterCard({
  datePreset,
  setDatePreset,
  dateRange,
  setDateRange,
}) {
  return (
    <Card
      sx={{
        mt: 1.5,
        borderRadius: '18px',
        border: '1px solid rgba(0,0,0,0.08)',
        boxShadow: 'none',
      }}
    >
      <MDBox sx={{ p: 1.25 }}>
        <MDTypography variant="button" fontWeight="bold">
          Tarih Aralığı
        </MDTypography>

        <Grid container spacing={1.25} sx={{ mt: 0.2 }}>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              select
              size="small"
              label="Dönem"
              value={datePreset}
              onChange={(e) => setDatePreset(e.target.value)}
            >
              {PRESETS.map((item) => (
                <MenuItem key={item.value} value={item.value}>
                  {item.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              size="small"
              type="date"
              label="Başlangıç"
              value={dateRange.startDate || getMonthStartISO()}
              onChange={(e) => {
                setDatePreset('CUSTOM');
                setDateRange((prev) => ({ ...prev, startDate: e.target.value }));
              }}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              size="small"
              type="date"
              label="Bitiş"
              value={dateRange.endDate || ''}
              onChange={(e) => {
                setDatePreset('CUSTOM');
                setDateRange((prev) => ({ ...prev, endDate: e.target.value }));
              }}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        </Grid>
      </MDBox>
    </Card>
  );
}
